import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';

export const GET_AUTH_METHOD_MESSAGE_TYPE = 'get_auth_method';
export const getAuthMethod = async (userId?: string) =>
  SocketAsFetch.fetch({
    message_type: GET_AUTH_METHOD_MESSAGE_TYPE,
    ...(userId && { info: { user_id: userId } }),
  });
